import { McpToolEditorModal } from '@circuitry-ai/doc-ui';
import type { McpToolVisibility } from '@circuitry-ai/doc-data';

export type { McpToolVisibility } from '@circuitry-ai/doc-data';

export interface EnableMcpToolModalProps {
    readonly isOpen: boolean;
    readonly defaultDescription: string;
    readonly defaultInputSchemaJson: string;
    readonly defaultVisibility?: McpToolVisibility;
    readonly isUpdateMode?: boolean;
    readonly isLoading?: boolean;
    readonly onOpenChange: (open: boolean) => void;
    readonly onConfirm: (
        description: string,
        inputSchemaJson: string,
        visibility: McpToolVisibility,
    ) => void;
}

export function EnableMcpToolModal({
    onConfirm,
    ...props
}: EnableMcpToolModalProps) {
    return (
        <McpToolEditorModal
            {...props}
            showInputSchema
            inputSchemaPlaceholder={'[\n  { "name": "serial_numbers", "type": "string", "required": true }\n]'}
            onConfirm={({ description, inputSchemaJson = '', visibility }) =>
                onConfirm(description, inputSchemaJson, visibility)
            }
        />
    );
}
